import isObject from 'lodash/isObject'
import reject from 'lodash/reject'
import * as React from 'react'

import {
  clientMasterSchema,
  clientToMergeSchema,
  schemasValidate,
} from '../../utils/schemas'
import { ZentakeContext } from '../../utils/ZentakeContext'

const initialFormError = {
  clientMaster: false,
  clientToMerge: false,
}

const initialFormErrorLabel = {
  clientMaster: undefined,
  clientToMerge: undefined,
}

function useMergeClientState(baseClientMaster) {
  const { clients } = React.useContext(ZentakeContext)

  const [clientMaster, setClientMaster] = React.useState(baseClientMaster)
  const [listForClientMaster, setListForClientMaster] = React.useState(clients)
  const [clientToMerge, setClientToMerge] = React.useState()
  const [listForClientsToMerge, setListForClientsToMerge] = React.useState([])

  const [hasFormError, setHasFormError] = React.useState(false)
  const [formError, setFormError] = React.useState(initialFormError)
  const [formErrorLabel, setFormErrorLabel] = React.useState(
    initialFormErrorLabel
  )

  const validateClientMaster = React.useCallback(async () => {
    await schemasValidate(
      [['clientMaster', clientMaster ?? {}, clientMasterSchema]],
      setFormError,
      setFormErrorLabel
    )
  }, [clientMaster])
  React.useEffect(() => {
    formError?.clientMaster === true && validateClientMaster()

    // remove client master from clients lists
    setListForClientsToMerge(() =>
      clientMaster?.id !== undefined
        ? reject(clients, (client) => client.id === clientMaster.id)
        : clients
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clients, clientMaster])

  const validateClientToMerge = React.useCallback(async () => {
    await schemasValidate(
      [['clientToMerge', clientToMerge ?? {}, clientToMergeSchema]],
      setFormError,
      setFormErrorLabel
    )
  }, [clientToMerge])
  React.useEffect(() => {
    formError?.clientToMerge === true && validateClientToMerge()

    // remove client master from clients lists
    setListForClientMaster(() =>
      clientToMerge?.id !== undefined
        ? reject(clients, (client) => client.id === clientToMerge.id)
        : clients
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clients, clientToMerge])

  React.useEffect(() => {
    setHasFormError((p) => {
      const n =
        isObject(formError) &&
        Object.values(formError)?.some((err) => err === true)
      return n !== p ? n : p
    })
  }, [formError])

  async function validateForm() {
    return await schemasValidate(
      [
        ['clientMaster', clientMaster ?? {}, clientMasterSchema],
        ['clientToMerge', clientToMerge ?? {}, clientToMergeSchema],
      ],
      setFormError,
      setFormErrorLabel
    )
  }

  return {
    clientMaster,
    clientToMerge,
    listForClientMaster,
    setClientMaster,
    setClientToMerge,
    listForClientsToMerge,

    hasFormError,
    formError,
    formErrorLabel,

    validateForm,
  }
}

export default useMergeClientState
